import { Injectable } from "@angular/core";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";
import { CLIENT_ID, PRESET_ID } from "../constants/constants";
import { ImportDialogData } from "../dialogs/import-dialog/import-dialog-data";

@Injectable({
  providedIn: "root",
})
export class ImportInspectionService {
  constructor(private httpService: HttpService) {}

  public importInspection(data: ImportDialogData[], file: File): Promise<void> {
    const formData = this.createFormData(data, file);
    return this.httpService
      .post(
        `${environment.webApiUrl}/api/inspection/uploadInspections`,
        formData,
        { withCredentials: true },
      )
      .toPromise();
  }

  private createFormData(data: ImportDialogData[], file: File): FormData {
    const formData = new FormData();
    formData.set("presetId", data.find((d) => d.id == PRESET_ID).value);
    formData.set("clientId", data.find((d) => d.id == CLIENT_ID).value);
    formData.set("client", data.find((d) => d.id == CLIENT_ID).name);
    formData.set("file", file);
    return formData;
  }
}
